import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subscription } from 'rxjs';
import { PASPrdService } from '../../../services/PASPrd.service';
import { ErrorStateMatcher1 } from '../../error-state-matcher1';
//import { IgrouppaslistResponse } from '../../Interfaces/igrouppas';
import { ILocationProductionResponse } from '../../Interfaces/ilocation';
//import { GRPASCCV1Detail } from '../../Interfaces/ipas';
import { AddPasOptionGroup, IPASOption, IPASOptions, listPOGTypes, POGStatus, POGType } from '../../Interfaces/iproduction';


@Component({
  selector: 'app-pasoptionadd',
  templateUrl: './pasoptionadd.component.html'
})

export class PASOptionAddComponent implements OnInit {
  formedit: FormGroup;
  subRef$: Subscription;
  matcher = new ErrorStateMatcher1();
  message: string = "";
  productionLocations: ILocationProductionResponse[];

  constructor(
    private formBuilder: FormBuilder,
    private PASPrdService:PASPrdService,
    private dialogRef: MatDialogRef<PASOptionAddComponent>,
    private _snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.formedit = formBuilder.group({
      code: ["", [Validators.required]],
      option: ["", [Validators.required]],
      selected: [true, [Validators.required]],
      statusBol: [true, [Validators.required]]
    });
  }
  groupId: number;

  ngOnInit() {
    this.groupId = this.data.groupId
    this.message = "";
  }

  Cancel() {
    this.dialogRef.close();
  }

  Save() {
    try {
      let _Message = "";
      const _Data: IPASOption = {
        code: this.formedit.value.code, status: (this.formedit.value.statusBol?'A':'I') ,
        option: this.formedit.value.option, selected: this.formedit.value.selected,
       idPASOptionsgroup:this.groupId
      };
      this.PASPrdService.AddPO(_Data).subscribe(result => {
            if (result.body.isValid) {
              _Message = result.body.resultData.description;
              this.openSB(_Message);
            }
            else {
              alert(result.body.error.description);
              return;
            }
          }, (e) => {
            alert(e);
            return;
          });
        this.dialogRef.close(true);
    }
    catch (e) {
      console.log(e.message);
      alert(e.message);
    }
  }

  hasError(nombreControl: string, validacion: string) {
    const control = this.formedit.get(nombreControl);
    return control.hasError(validacion);
  }

  openSB(msg) {
    this._snackBar.open(msg, '', {
      duration: 3000, horizontalPosition: "center", verticalPosition: "top", panelClass: ['snackbarmsg']
    });
  }

  ngOnDestroy(): void {
  }
}
